import React, { useState } from "react";

const Contact = () => {

const [form,setForm] = useState({
name:"",
email:"",
subject:"",
phone:"",
message:""
})

const handleChange = (e)=>{
setForm({
...form,
[e.target.name]:e.target.value
})
}

const handleSubmit = async(e)=>{
e.preventDefault();

console.log(form);

try{

const res = await fetch("https://lifetimeinfotech.in/backend/contact.php",{
method:"POST",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify(form)
})

const data = await res.json();

console.log(data);

alert(data.message);

}catch(error){
console.log(error);
}

}

return (
<section className="contact-section">



      <div className="contact-header">
          <h1>Contact Us</h1>
        <p>
          Have a project in mind or need help with your digital solution?
          Our team is here to assist you. Get in touch with us and let's build
          something amazing together.
        </p>
      </div>

      <div className="contact-container">
<div className="contact-info">

          <h2>Get In Touch</h2>

          <p>
            We would love to hear from you. Whether you have a question about
            our services, pricing, or anything else, our team is ready to
            answer all your questions.
          </p>

          <div className="info-item">
            <i className="bi bi-geo-alt"></i>
            <div>
              <h4>Address</h4>
              <span>Surat, Gujarat, India</span>
            </div>
          </div>

          <div className="info-item">
            <i className="bi bi-telephone"></i>
            <div>
              <h4>Phone</h4>
              <span>+91 98765 43210</span>
            </div>
          </div>

          <div className="info-item">
            <i className="bi bi-envelope"></i>
            <div>
              <h4>Email</h4>
              <span>info@lifetimeinfotech.com</span>
            </div>
          </div>
</div>



<div className="contact-form">
<h2>Send Us a Message</h2>

<form onSubmit={handleSubmit}>

<div className="form-group">
<input
type="text"
name="name"
placeholder="Full Name"
value={form.name}
onChange={handleChange}
/>
</div>

<div className="form-group">
<input
type="email"
name="email"
placeholder="Email Address"
value={form.email}
onChange={handleChange}
/>
</div>

<div className="form-group">
<input
type="text"
name="subject"
placeholder="Subject"
value={form.subject}
onChange={handleChange}
/>
</div>

<div className="form-group">
<input
type="text"
name="phone"
placeholder="Phone Number"
value={form.phone}
onChange={handleChange}
/>
</div>

<div className="form-group">
<textarea
rows="5"
name="message"
placeholder="Write your message..."
value={form.message}
onChange={handleChange}
/>
</div>

<button type="submit" className="contact-btn">
Send Message
</button>

</form>

</div>

</div>

 <div className="map-section">
  <iframe
    title="Google Map"
    src="https://www.google.com/maps?q=21.2188789,72.85137&z=15&output=embed"
    width="100%"
    height="350"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
  ></iframe>
</div>
</section>
);
}

export default Contact;